import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumJourneyStopPlanningStatus implements BaseEnumType {
  private static allValues: EnumJourneyStopPlanningStatus[] = []; // make sure this is top-most
  
  public static unknown = new EnumJourneyStopPlanningStatus(0, "Unknown", "enum_journey_stop_planning_status_unknown");
  public static onFinishedJourney = new EnumJourneyStopPlanningStatus(1, "OnFinishedJourney", "enum_journey_stop_planning_status_on_finished_journey");
  public static onStartedJourney = new EnumJourneyStopPlanningStatus(2, "OnStartedJourney", "enum_journey_stop_planning_status_on_started_journey");
  public static onPlanningLockedJourney = new EnumJourneyStopPlanningStatus(3, "OnPlanningLockedJourney", "enum_journey_stop_planning_status_on_planning_locked_journey");
  public static onPlannedJourney = new EnumJourneyStopPlanningStatus(4, "OnPlannedJourney", "enum_journey_stop_planning_status_on_planned_journey");
  public static requiresPlanning = new EnumJourneyStopPlanningStatus(5, "RequiresPlanning", "enum_journey_stop_planning_status_requires_planning");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumJourneyStopPlanningStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumJourneyStopPlanningStatus.unknown; }
  public isOnFinishedJourney() { return this === EnumJourneyStopPlanningStatus.onFinishedJourney; }
  public isOnStartedJourney() { return this === EnumJourneyStopPlanningStatus.onStartedJourney; }
  public isOnPlanningLockedJourney() { return this === EnumJourneyStopPlanningStatus.onPlanningLockedJourney; }
  public isOnPlannedJourney() { return this === EnumJourneyStopPlanningStatus.onPlannedJourney; }
  public isRequiresPlanning() { return this === EnumJourneyStopPlanningStatus.requiresPlanning; }

  public static getValues(): readonly EnumJourneyStopPlanningStatus[] {
    return EnumJourneyStopPlanningStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumJourneyStopPlanningStatus[] {
    return EnumJourneyStopPlanningStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumJourneyStopPlanningStatus {
    const found = EnumJourneyStopPlanningStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumJourneyStopPlanningStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumJourneyStopPlanningStatus): EnumJourneyStopPlanningStatus {
    const found = name ? EnumJourneyStopPlanningStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumJourneyStopPlanningStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumJourneyStopPlanningStatus>): boolean {
    return this.key === other?.key;
  }
}